import {
  SET_WORK_TIME, SET_WORK_TIME_ID, UPDATE_CREDIT, CHECK_WORK_TIME,
} from './mutation-types';

export default {
  [SET_WORK_TIME](state, time) {
    state.workTime = time;
    if (time) {
      localStorage.setItem('workTime', time);
    } else {
      localStorage.removeItem('workTime');
    }
  },
  [SET_WORK_TIME_ID](state, id) {
    state.workTimeId = id;
    if (id) {
      localStorage.setItem('workTimeId', id);
    } else {
      localStorage.removeItem('workTimeId');
    }
  },
  [CHECK_WORK_TIME](state) {
    state.workTime = localStorage.getItem('workTime') || null;
    state.workTimeId = localStorage.getItem('workTimeId') || null;
  },
  [UPDATE_CREDIT](state, payload) {
    state.credit = payload.credit;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/common/mutations.js